import React, { useState } from 'react';
import { FailureReason } from '../driverActiveDeliveriesTypes';
import styles from './ReportFailure.module.css';

interface ReportFailureProps {
  reasons: FailureReason[];
  onSubmit?: (input: { reasonId: string; notes?: string }) => void | Promise<void>;
  onCancel?: () => void;
  submitting?: boolean;
}

export const ReportFailure: React.FC<ReportFailureProps> = ({ reasons, onSubmit, onCancel, submitting }) => {
  const [selected, setSelected] = useState<string>('');
  const [notes, setNotes] = useState('');

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Report Delivery Failure</h3>

      <div className={styles.reasonList}>
        {reasons.map((reason) => (
          <button
            key={reason.id}
            type="button"
            className={`${styles.reasonBtn} ${selected === reason.id ? styles.reasonBtnActive : ''}`}
            onClick={() => setSelected(reason.id)}
          >
            {reason.label}
          </button>
        ))}
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Failure Notes (Optional)</label>
        <textarea
          className={styles.textarea}
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>

      <div className={styles.actions}>
        <button
          className={styles.submitBtn}
          disabled={!selected || submitting}
          onClick={() => onSubmit?.({ reasonId: selected, notes: notes.trim() || undefined })}
        >
          {submitting ? 'Submitting…' : 'Submit Failure Report'}
        </button>
        <button className={styles.cancelBtn} onClick={() => onCancel?.()}>Cancel</button>
      </div>
    </div>
  );
};
